import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkmj } from '../entity/Stkmj-angular';

export const StkMj004List = [{ id: "1", name: "群組" }, { id: "2", name: "個股" }, { id: "3", name: "全市場" }]; // 個股或群組
export const StkMj023List = [{ id: "L", name: "Line" }, { id: "T", name: "TELEGRAM" }, { id: "M", name: "MAIL" }]; // 通知方法
export const StkMj024List = [{ id: "1", name: "只一次" }, { id: "2", name: "通知到已讀" }, { id: "3", name: "不斷通知" }]; // 通知頻率

@Injectable({
  providedIn: 'root'
})
export class StkmjServicePkg extends JkEntityV2 {
  StkMj004List = StkMj004List;
  StkMj023List = StkMj023List;
  StkMj024List = StkMj024List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkmj();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MJ001: '帳號代號', MJ002: '條件代號', MJ003: '名稱', MJ004: '個股或群組', MJ005: '群組代號', MJ006: '多空指標', MJ007: '條件說明', MJ011: '排序', MJ016: '成交量N張以上', MJ019: '啟用', MJ020: '開始時間', MJ021: '結束時間', MJ022: '間格時間(分)', MJ023: '通知方法', MJ024: '通知頻率', MJ025: '上次選股日期', MJ026: '上次選股時間', MJ027: '條件程式碼', MJ116: '跌幅', MJ117: '大黑K棒實體N%以上', MJ118: '小黑K棒實體N%以上', MJ119: '三陽開泰且爆量小紅', MJ120: '四海遊龍且爆量小紅', MJ029: '函數名1', MJ030: '參數1(JSON格式)', MJ032: '函數名2', MJ033: '參數2', MJ035: '函數名3', MJ036: '參數3', MJ038: '函數名4', MJ039: '參數4', MJ041: '函數名5', MJ042: '參數5'
    };

    this.fieldNames = 'MJ001,MJ002,MJ003,MJ004,MJ005,MJ006,MJ007,MJ011,MJ016,MJ019,MJ020,MJ021,MJ022,MJ023,MJ024,MJ025,MJ026,MJ027,MJ116,MJ117,MJ118,MJ119,MJ120,MJ029,MJ030,MJ032,MJ033,MJ035,MJ036,MJ038,MJ039,MJ041,MJ042';
    this.fieldLengths = { MJ001: 6, MJ002: 6, MJ003: 30, MJ004: 1, MJ005: 40, MJ006: 10, MJ007: 2000, MJ011: 8, MJ016: 8.4, MJ019: 1, MJ020: 8, MJ021: 8, MJ022: 6, MJ023: 1, MJ024: 1, MJ025: 8, MJ026: 8, MJ027: 500, MJ116: 1, MJ117: 1, MJ118: 1, MJ119: 1, MJ120: 1, MJ029: 30, MJ030: 255, MJ032: 30, MJ033: 255, MJ035: 30, MJ036: 255, MJ038: 30, MJ039: 255, MJ041: 30, MJ042: 255 };
    this.columnDefs = [
      { field: "MJ001", headerName: "帳號代號", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MJ002", headerName: "條件代號", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MJ003", headerName: "名稱", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MJ019", headerName: "啟用", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "MJ005", headerName: "群組代號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MJ006", headerName: "多空指標", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MJ004", headerName: "個股或群組", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkMj004List }, },
      { field: "MJ007", headerName: "條件說明", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MJ016", headerName: "成交量N張以上", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ022", headerName: "間格時間(分)", headerTooltip: "", width: 118, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ044", headerName: "保留", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ043", headerName: "保留", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ027", headerName: "條件程式碼", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MJ029", headerName: "函數名1", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MJ030", headerName: "參數1(JSON格式)", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MJ032", headerName: "函數名2", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MJ033", headerName: "參數2", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MJ035", headerName: "函數名3", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MJ036", headerName: "參數3", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MJ038", headerName: "函數名4", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MJ039", headerName: "參數4", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MJ041", headerName: "函數名5", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MJ042", headerName: "參數5", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MJ011", headerName: "排序", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ012", headerName: "保留", headerTooltip: "", width: 136, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ013", headerName: "保留", headerTooltip: "", width: 136, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ014", headerName: "保留", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ015", headerName: "保留", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ017", headerName: "保留", headerTooltip: "", width: 136, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ018", headerName: "保留", headerTooltip: "", width: 136, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MJ026", headerName: "上次選股時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "MJ025", headerName: "上次選股日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
    ];
    this.columnDefsVir = [
      { field: "MJ001C1", headerName: "帳號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MJ001C2", headerName: "帳戶名稱", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MJ005C1", headerName: "群組名稱", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MJ005C2", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.tableName = 'STKMJ';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMJ.*,MB002 AS MJ001C1,MB003 AS MJ001C2,ME002 AS MJ005C1,ME003 AS MJ005C2
FROM STKMJ
LEFT JOIN STKMB ON MJ001=MB001
LEFT JOIN STKME ON MJ005=ME001` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MJ001,MJ002`;
    this.keyFields = ['MJ001', 'MJ002'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MJ001', 'MJ002'];
    this.seqField = '';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stkmj): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkmj): Promise<Stkmj> {
    await super.newRecord(newItem);
    return newItem;
  }



  async MJ001Change(value: any) { // 帳號代號
    let bool = await this.advCheck('MJ001', this.item, 'STKMB', 'V01', 'MJ001C1,MJ001C2', [this.item.MJ001], 'E', '帳號代號錯誤.');
  }
  async MJ005Change(value: any) { // 群組代號
    let bool = await this.advCheck('MJ005', this.item, 'STKME', 'V01', 'MJ005C1,MJ005C2', [this.item.MJ005], 'E', '群組代號錯誤.');
  }

}

// 客製開始====================================================
